let getCurrentDateAndTime = () => {
    let currentDateAndTime = new Date()
        .toLocaleString()
        .replace("г.,", "")
        .replace(" ч.", "");
    return currentDateAndTime;
};
export default getCurrentDateAndTime;